export function mapByField(collection, field) {
  return collection.reduce((acc, item) => {
    acc[item[field]] = item;
    return acc;
  }, {});
}
export function mapById(collection) {
  return mapByField(collection, 'id');
}
//# sourceMappingURL=map-by-field.js.map